import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 約定・発生 */
enum ContractGeneration {
  agreement = '1',
  occurrence = '2',
  occurrenceYear = '3',
  agreementInterestOccurrence = '4',
}

const nameConfig = {
  agreement: new Map([
    [Locale.ja, '約定'],
    [Locale.en, 'Agreement'],
  ]),
  occurrence: new Map([
    [Locale.ja, '発生'],
    [Locale.en, 'Occurrence'],
  ]),
  occurrenceYear: new Map([
    [Locale.ja, '発生(年)'],
    [Locale.en, 'Occurrence Year'],
  ]),
  agreementInterestOccurrence: new Map([
    [Locale.ja, '約定(利息発生)'],
    [Locale.en, 'Agreement Interest Occurrence'],
  ]),
};

const toEnum = rawValueToEnum(ContractGeneration, '');
const toDisplay = enumToName(ContractGeneration, nameConfig);
const toDisplayWithPrefix = enumToName(ContractGeneration, nameConfig, { prefix: true });

export const contractGeneration = {
  enum: ContractGeneration,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ContractGeneration };
